import { NavLink, useParams } from 'react-router-dom';
import './FAQ.css';

const faqData = {
  'was-ist-gta-v-rp-roleplay': {
    title: 'Was ist GTA V RP / Roleplay?',
    intro: [
      'GTA V Roleplay (GTA RP) ist Multiplayer-Rollenspiel in der Welt von Grand Theft Auto V: Du spielst einen festen Charakter auf Community-Servern (meist FiveM), folgst Regeln und entwickelst Stories mit anderen — statt nur Rockstars Story-Missionen oder klassisches GTA Online.',
      'Bei Salerno Roleplay spielst du deinen Charakter auf einem deutschsprachigen FiveM-Server mit aktiver Community, klaren Regeln und vielen Rollen — von Polizei über Ziviljobs bis zu Fraktionen.',
      'Wichtig sind realistisches Verhalten und Serverregeln. Bei uns gilt ein strenges Regelwerk zu RDM, VDM, IC/OOC und Powergaming. Entstehungsgeschichte: Wie ist GTA V RP entstanden?',
    ],
    sections: [
      {
        title: 'Die Grundprinzipien',
        items: [
          { type: 'list', value: ['Authentische Charakterdarstellung', 'Realistische Interaktionen', 'Konsequentes Handeln', 'Respektvoller Umgang', 'Kreative Geschichtenerzählung'] },
        ],
      },
      {
        title: 'Die Salerno-Community',
        items: [
          { type: 'text', value: 'Die Salerno-Community erzählt gemeinsam Geschichten und hält die Spielwelt am Laufen. Auf unserem Discord findest du Support, Bewerbungen und aktuelle Ankündigungen. Streams auf RP Streams zeigen, wie unsere Server und Charaktere im Alltag wirken.' },
        ],
      },
      {
        title: 'Mögliche Rollen',
        items: [
          { type: 'list', value: ['Polizist oder Detektiv', 'Arzt oder Sanitäter', 'Mechaniker oder Autohändler', 'Restaurantbesitzer oder Koch', 'Journalist oder Reporter', 'Taxifahrer oder Lieferant', 'Kleinkrimineller oder Gangmitglied', 'Bürgermeister oder Politiker'] },
        ],
      },
      {
        title: 'Die Spielwelt',
        items: [
          { type: 'text', value: 'Basis ist Los Santos aus GTA V, oft erweitert um Jobs, Immobilien und Server-Features. Spieler können:' },
          { type: 'list', value: ['Immobilien kaufen und einrichten', 'Geschäfte eröffnen und führen', 'Jobs annehmen und Karriere machen', 'Beziehungen aufbauen und pflegen', 'An Events und Aktivitäten teilnehmen'] },
          { type: 'text', value: 'Begriffe wie IC, OOC, RDM: RP-Glossar. Einstieg: Wie kann man GTA RP spielen?' },
        ],
      },
    ],
  },
  'wie-ist-gta-v-rp-entstanden': {
    title: 'Wie ist GTA V RP / Roleplay entstanden?',
    intro: [
      'GTA V Roleplay entstand aus der Modding-Community nach Release 2013: Frühe Anpassungen führten zu Multiplayer-Frameworks wie FiveM und RageMP, darauf bauten die ersten RP-Server mit Jobs, Regeln und Economy auf. Heute ist es ein etabliertes Format mit großen deutschsprachigen Projekten wie Salerno Roleplay.',
    ],
    sections: [
      {
        title: 'Die Anfänge',
        items: [
          { type: 'text', value: 'Kurz nach der Veröffentlichung von GTA V 2013 experimentierten Modder damit, das Spiel für Roleplay nutzbar zu machen. Die ersten Lösungen waren einfach und beschränkten sich auf grundlegende Funktionen — ohne die späteren Economy- und Fraktions-Systeme.' },
        ],
      },
      {
        title: 'Die ersten Server',
        items: [
          { type: 'text', value: 'Mit FiveM und RageMP entstanden die ersten Roleplay-Server: Jobs, Häuser, Fahrzeuge und Community-Regeln. Die Szene wuchs schnell und etablierte Standards zu IC/OOC und Verboten wie RDM/VDM. Heute betreiben wir Salerno Roleplay als eines dieser deutschsprachigen Projekte.' },
        ],
      },
      {
        title: 'Die Herausforderungen',
        items: [
          { type: 'text', value: 'Technische Limits, Plattform-Vorgaben und der Aufbau funktionierender Wirtschaftssysteme forderten Betreiber und Entwickler. Stabilität, Fairness und Anti-Cheat blieben Dauerthemen — auch für uns bei Salerno.' },
        ],
      },
      {
        title: 'Die Verbesserungen',
        items: [
          { type: 'text', value: 'Neue Scripts ermöglichten komplexere Interaktionen, bessere Economy und tiefere Charakterentwicklung. Die RP-Qualität stieg — parallel wuchs die Streaming-Szene, die Server wie Salerno sichtbar machte.' },
        ],
      },
      {
        title: 'Die Community',
        items: [
          { type: 'text', value: 'Aus kleinen Projekten wurde eine der größten GTA-V-Communities. Tausende Spieler erzählen parallel Stories; deutsche Server wie Salerno entwickelten eigene Kulturen und Whitelist-Prozesse.' },
        ],
      },
      {
        title: 'Die heutige Situation',
        items: [
          { type: 'text', value: 'Heute ist GTA V Roleplay etabliert: professionelle Server, klare Regelwerke und laufende Features. Wer bei Salerno Roleplay spielen möchte, tritt unserem Discord bei !' },
        ],
      },
    ],
  },
  'was-benoetigt-man': {
    title: 'Was benötigt man um Roleplay spielen zu können?',
    intro: [
      'Um bei Salerno Roleplay spielen zu können, brauchst du: leistungsfähigen PC, legale GTA-V-Version, FiveM-Client, stabile Internetleitung, Headset/Mikrofon und unseren Discord. Alle Voraussetzungen findest du im Discord im Detail.',
    ],
    sections: [
      {
        title: 'Einen Gaming-Computer',
        items: [
          { type: 'text', value: 'GTA V und FiveM brauchen CPU, RAM und GPU mit Reserven. Praktisch: 16 GB RAM oder mehr, SSD und eine Grafikkarte, die GTA V in akzeptablen FPS hält — auf RP-Servern wie Salerno kommen oft zusätzliche Assets und Scripts dazu.' },
          { type: 'text', value: 'Konsolen reichen für klassisches FiveM-RP nicht; siehe GTA RP auf PS5/PS4. Salerno Roleplay läuft ausschließlich auf PC über FiveM.' },
        ],
      },
      {
        title: 'Eine stabile Internetverbindung',
        items: [
          { type: 'text', value: 'Roleplay läuft online: Ping-Spitzen und Packet Loss stören Voice und Sync. Eine stabile Leitung (nicht nur hohe Download-Zahlen) ist wichtiger als theoretisches Maximum. WLAN kann funktionieren, Kabel ist zuverlässiger — besonders für flüssiges RP auf Salerno.' },
        ],
      },
      {
        title: 'GTA V',
        items: [
          { type: 'text', value: 'Du brauchst eine legale PC-Kopie von Grand Theft Auto V (Steam, Epic Games Store oder Rockstar Launcher). Salerno Roleplay setzt eine vollständig installierte und einmal gestartete Version voraus.' },
        ],
      },
      {
        title: 'GTA V Roleplay-Client',
        items: [
          { type: 'text', value: 'Bei Salerno Roleplay nutzen wir FiveM als Standard-Client. Den Client lädst du von der offiziellen Seite und verknüpfst ihn mit deinem Rockstar-Konto. Alt:V und RageMP werden bei uns nicht unterstützt.' },
        ],
      },
      {
        title: 'Discord',
        items: [
          { type: 'text', value: 'Bewerbung, Support und Community laufen bei Salerno ausschließlich über Discord. Ohne Discord-Zugang kommst du bei unserer Whitelist nicht weiter. Hier findest du alle Infos, Regeln und Ankündigungen.' },
        ],
      },
      {
        title: 'Ein Mikrofon',
        items: [
          { type: 'text', value: 'Voice-RP ist auf Salerno Roleplay Standard. Headset mit klarem Mikrofon ist Pflicht — Text-only reicht selten für Fraktionen und Alltagsszenen auf unserem Server.' },
        ],
      },
      {
        title: 'Die Bereitschaft zur Einhaltung von Regeln',
        items: [
          { type: 'text', value: 'Salerno Roleplay hat ein strenges Regelwerk (RDM/VDM, IC/OOC, Fail RP, Powergaming). Regeln lesen und respektieren ist Teil der Voraussetzung für einen festen Platz in unserer Community.' },
        ],
      },
    ],
  },
  'wie-kann-ich-rp-spielen': {
    title: 'Ich habe ein PC, wie kann ich Roleplay spielen?',
    intro: [
      'Bei Salerno Roleplay startest du so: FiveM installieren, Rockstar-Konto verknüpfen, unseren Discord beitreten, Whitelist abschließen und auf Salerno joinen. Diese Seite fokussiert Setup und ersten Join — nicht den allgemeinen Überblick oder die reine Voraussetzungen-Liste.',
    ],
    sections: [
      {
        title: 'Die Launcher',
        items: [
          { type: 'text', value: 'Bei Salerno Roleplay nutzen wir FiveM als einzigen unterstützten Client. Du lädst FiveM von der offiziellen Seite; er erkennt die installierte PC-Version von GTA V. Nach dem Start siehst du eine Serverliste.' },
          { type: 'text', value: 'GTA V einmal nativ starten, bevor du FiveM öffnest. So vermeidest du typische Verknüpfungs- und Cache-Fehler beim ersten Join auf Salerno.' },
        ],
      },
      {
        title: 'Die Whitelist',
        items: [
          { type: 'text', value: 'Salerno Roleplay verwendet eine Whitelist: Du bewirbst dich schriftlich oder mündlich per Discord. Nach erfolgreicher Prüfung erhältst du Zugang zum Server. Die Whitelist sichert die Qualität unseres Roleplays.' },
        ],
      },
      {
        title: 'Die Regeln beim ersten Join',
        items: [
          { type: 'text', value: 'Sobald du den Server betrittst, gelten die Salerno Roleplay-Regeln. IP und Voice-Infos stehen in unserem Discord. Halte dich an RDM/VDM-Verbote, trenne IC und OOC, und respektiere die Community — dann steht deinem Einstieg nichts im Weg.' },
        ],
      },
    ],
  },
  'was-sollte-ich-beachten': {
    title: 'Was sollte ich beachten um Roleplay zu spielen?',
    intro: [
      'Bei Salerno Roleplay zählen Respekt, nachvollziehbares IC-Verhalten und unsere Serverregeln: kein Ragen, kein RDM/VDM ohne Story, klar trennen zwischen IC und OOC. Wer ruhig startet und zuhört, kommt weiter als mit sofortiger Eskalation — Details und Do’s/Don’ts folgen.',
    ],
    sections: [
      {
        title: 'Respektvoller Umgang',
        items: [
          { type: 'text', value: 'Behandle andere Spieler höflich — auch bei Konflikten. Beleidigungen, Diskriminierung und unangemessenes Verhalten haben im RP nichts zu suchen. Meinungsverschiedenheiten sachlich und konstruktiv klären; Eskalation OOC gehört in den Support-Kanal von Salerno, nicht in die Szene.' },
        ],
      },
      {
        title: 'Rücksichtsvolles Verhalten',
        items: [
          { type: 'text', value: 'Handlungen sollten für deinen Charakter nachvollziehbar sein. Überlege, wie die Figur reagieren würde — vermeide übertriebene Power-Moves, die das Erlebnis anderer zerstören.' },
          { type: 'text', value: 'Zu den häufigsten Hard-Rules bei Salerno gehören RDM und VDM.' },
        ],
      },
      {
        title: 'Kein Ragen',
        items: [
          { type: 'text', value: 'Ragen meint absichtliches Provozieren, Beleidigen oder Ausrasten gegenüber anderen Spielern — oft OOC. Das ist auf Salerno verboten und wird sanktioniert. Bleib fair; Frust gehört in eine Pause, nicht in Voice oder Chat.' },
        ],
      },
      {
        title: 'IC und OOC trennen',
        items: [
          { type: 'text', value: 'Wissen aus Discord, Streams oder OOC-Chat darf dein Charakter nicht nutzen (Metagaming). Alle Begriffe findest du unter "Alle GTA Roleplay Begriffe auf einen Blick". Das Regelwerk von Salerno vor dem Join lesen — nicht erst nach der ersten Warnung.' },
        ],
      },
    ],
  },
  'glossar': {
    title: 'Alle GTA Roleplay Begriffe auf einen Blick',
    intro: [
      'Dieses Glossar erklärt die wichtigsten GTA-RP-Begriffe kompakt: IC, OOC, Fail RP, Metagaming, Powergaming, RDM, VDM und Whitelist. So ordnest du Regeln, Chats und Serverinfos auf Salerno Roleplay schneller ein — ohne langes Suchen in Discord-Pins.',
      'Neu bei GTA RP? Kein Problem, wir von Salerno helfen dir !',
    ],
    sections: [
      {
        title: 'IC (In Character)',
        items: [
          { type: 'text', value: 'IC bedeutet In Character: alles, was dein Charakter im Spiel tut oder sagt. Du agierst als Figur, nicht als Spieler hinter dem Bildschirm. Auf Salerno Roleplay erwarten wir durchgehendes IC-Verhalten.' },
        ],
      },
      {
        title: 'OOC (Out of Character)',
        items: [
          { type: 'text', value: 'OOC steht für Out of Character: Kommunikation oder Wissen außerhalb der Rolle — z. B. Discord Support oder Meta-Hinweise. OOC und IC klar trennen; auf Salerno gibt es dafür extra Kanäle.' },
        ],
      },
      {
        title: 'Fail RP',
        items: [
          { type: 'text', value: 'Fail RP sind Handlungen gegen Realismus oder Serverregeln — unlogisches Charakterverhalten oder Ignorieren der Spielwelt. Oft Warngrund auf Salerno Roleplay.' },
        ],
      },
      {
        title: 'Powergaming',
        items: [
          { type: 'text', value: 'Powergaming: dem Charakter unrealistische Vorteile oder erzwungene Outcomes geben, ohne dem Gegenüber Spielraum zu lassen. Auf Salerno Roleplay streng verboten.' },
        ],
      },
      {
        title: 'Metagaming',
        items: [
          { type: 'text', value: 'Metagaming: OOC-Wissen IC nutzen (Stream, Discord, Freundesinfo), das der Charakter nicht haben könnte. Zerstört Fairness und Immersion — auf Salerno wird es sanktioniert.' },
        ],
      },
      {
        title: 'RDM (Random Deathmatch)',
        items: [
          { type: 'text', value: 'RDM: willkürliches Töten ohne RP-Grund. Auf Salerno Roleplay eine der schwersten Regelverletzungen und führt oft zu Bans.' },
        ],
      },
      {
        title: 'VDM (Vehicle Deathmatch)',
        items: [
          { type: 'text', value: 'VDM: Töten oder Angreifen mit dem Fahrzeug ohne sinnvolle RP-Begründung. Ebenfalls Hard-Rule auf Salerno Roleplay und wird konsequent geahndet.' },
        ],
      },
      {
        title: 'Whitelist',
        items: [
          { type: 'text', value: 'Whitelist: Freigabeliste für den Serverzugang — bei Salerno Roleplay nach Bewerbung oder Ingame-Prüfung im Discord.' },
        ],
      },
    ],
  },
  'wie-kann-man-gta-rp-spielen': {
    title: 'Wie kann man GTA RP spielen?',
    intro: [
      'GTA RP spielst du auf dem PC mit legalem GTA V und FiveM. Bei Salerno Roleplay installierst du FiveM, trittst unserem Discord bei, absolvierst die Whitelist und startest mit einem festen Charakter auf unserem Server. Konsolen wie PS5/PS4 bieten kein vollwertiges FiveM-RP.',
    ],
    sections: [
      {
        title: 'Der typische Einstieg bei Salerno',
        items: [
          { type: 'list', value: ['1) GTA V auf dem PC installieren und einmal starten.', '2) FiveM herunterladen und mit dem Rockstar-Konto verknüpfen.', '3) Tritt unserem Discord bei und lies das Regelwerk.', '4) Bewirb dich um die Whitelist.', '5) Charakter anlegen und die ersten Stunden beobachten statt eskalieren.'] },
        ],
      },
      {
        title: 'Serverwahl und Regeln',
        items: [
          { type: 'text', value: 'Bei Salerno Roleplay gilt: Bleib in Character (IC), vermeide OOC-Mix in Szenen und halte dich an Verbote wie RDM und VDM. Unser Regelwerk ist im Discord einsehbar. Vergleiche uns gerne mit anderen Servern im Servervoting.' },
        ],
      },
      {
        title: 'Was du brauchst',
        items: [
          { type: 'text', value: 'Kurz: GTA V PC, FiveM, stabiles Internet, Headset und unser Discord. Die vollständige Checkliste steht unter Was braucht man für GTA RP? und detailliert unter Voraussetzungen für Roleplay.' },
        ],
      },
    ],
  },
  'was-braucht-man-fuer-gta-rp': {
    title: 'Was braucht man für GTA RP?',
    intro: [
      'Für Salerno Roleplay brauchst du: legale GTA-V-PC-Version, FiveM-Client, stabile Internetleitung, Headset mit Mikrofon, unseren Discord und das Verständnis für unser Regelwerk. Whitelist und Discord-Bewerbung sind bei uns Pflicht — Details folgen unten.',
    ],
    sections: [
      {
        title: 'Kurzliste Hardware & Software',
        items: [
          { type: 'list', value: ['PC mit ausreichend RAM (idealerweise 16 GB+) und SSD', 'GTA V für Windows (Steam, Rockstar Launcher oder Epic)', 'FiveM (offizieller Client) und Rockstar-Konto', 'Headset/Mikrofon für Voice-RP', 'Discord für die Salerno-Community und Support'] },
        ],
      },
      {
        title: 'Welche GTA-Version für FiveM?',
        items: [
          { type: 'text', value: 'FiveM setzt auf deine installierte PC-Version von GTA V. Das Spiel sollte vollständig installiert und einmal gestartet sein. Konsolen-Versionen reichen für Salerno Roleplay nicht aus — siehe auch GTA RP auf PS5/PS4.' },
        ],
      },
      {
        title: 'Mehr Details & nächste Schritte',
        items: [
          { type: 'text', value: 'Ausführliche Voraussetzungen stehen unter Was benötigt man um Roleplay spielen zu können?. Den Einstieg bei Salerno findest du unter Wie kann man GTA RP spielen?' },
        ],
      },
    ],
  },
  'deutsche-rp-server': {
    title: 'GTA RP Server deutsch Liste',
    intro: [
      'Eine starre Namensliste deutscher GTA-RP-Server veraltet schnell. Bei Salerno Roleplay findest du aktuelle Signale wie Community, Moderation, Events und nachvollziehbare Bewertungen — und kannst uns direkt im Servervoting vergleichen.',
    ],
    sections: [
      {
        title: 'Woran erkennst du gute Server?',
        items: [
          { type: 'text', value: 'Achte auf klares Regelwerk (RDM/VDM, IC/OOC), aktive und faire Moderation, erreichbaren Discord und stabile Spielerzahlen. Bei Salerno Roleplay haben wir transparente Sanktionen, regelmäßige Events und eine deutschsprachige Community.' },
          { type: 'list', value: ['Transparente Sanktionen und Team-Kommunikation', 'Regelmäßige Events ohne Pay-to-Win-Druck', 'Deutschsprachige Community und Support-Zeiten', 'Nachvollziehbare Bewertungen statt nur Screenshot-Marketing'] },
        ],
      },
      {
        title: 'Serververgleich ohne Stress',
        items: [
          { type: 'text', value: 'Statische Listen im Netz sind oft veraltet oder bezahlt. Nutze aktuelle Bewertungen und Aktivitätsdaten, teste den Ton in Streams und lies das Regelwerk vor der Bewerbung bei Salerno. Für den Einstieg hilft die Schritt-für-Schritt-Checkliste.' },
        ],
      },
    ],
  },
  'rdm-und-vdm': {
    title: 'Was ist RDM und VDM in RP?',
    intro: [
      'RDM (Random Deathmatch) ist grundloses Töten zu Fuß, VDM (Vehicle Deathmatch) mit dem Fahrzeug — ohne nachvollziehbare In-Character-Situation. Auf Salerno Roleplay sind beide Regelverstöße und führen oft zu Warns oder Bans. Hier die Bedeutung, der Unterschied und typische Beispiele.',
    ],
    sections: [
      {
        title: 'RDM einfach erklärt',
        items: [
          { type: 'text', value: 'RDM steht für Random Deathmatch: Du tötest oder schießt ohne RP-Hintergrund — etwa weil jemand „im Weg steht“ oder du Lust auf Action hast. Erlaubt ist Gewalt nur, wenn dein Charakter einen klaren IC-Grund hat (Konflikt, Auftrag, Selbstverteidigung im Rahmen der Salerno-Regeln).' },
          { type: 'text', value: 'Viele Server verlangen vorherige Interaktion (z. B. Ansprechen, Fluchtchance) und verbieten „Shoot on Sight“ ohne Story. Bei Salerno Roleplay ist das keine Ausnahme — lies unser Regelwerk, bevor du eskalierst.' },
        ],
      },
      {
        title: 'VDM einfach erklärt',
        items: [
          { type: 'text', value: 'VDM bedeutet Vehicle Deathmatch: Das Fahrzeug wird als Waffe genutzt — Überfahren, Rammen oder gezieltes Plattschieben ohne sinnvolle RP-Begründung. Auch „nur zum Spaß“ durch Fußgängerzonen rasen und Leute mitnehmen zählt bei Salerno als VDM.' },
          { type: 'text', value: 'Unfälle im normalen Straßenverkehr sind etwas anderes: Entscheidend ist Absicht und fehlender RP-Kontext. Bei Unsicherheit: anhalten, IC reagieren und nicht weiter eskalieren.' },
        ],
      },
      {
        title: 'Warum ist das wichtig?',
        items: [
          { type: 'text', value: 'RDM und VDM zerstören Immersion und Storys anderer Spieler. Deshalb ahnden wir auf Salerno Roleplay sie konsequent. Wer neu einsteigt, beobachtet lieber erste Stunden und fragt im Discord nach Grauzonen.' },
          { type: 'text', value: 'Weitere Begriffe (IC, OOC, Fail RP, Metagaming) stehen im RP-Glossar. Verhaltensregeln insgesamt: Was sollte ich beachten?' },
        ],
      },
    ],
  },
  'gta-online-voraussetzungen': {
    title: 'Was braucht man um GTA 5 Online zu spielen?',
    intro: [
      'Für GTA 5 Online brauchst du eine legale GTA-V-Lizenz mit Online-Zugang, ein Rockstar-Konto und stabile Internetverbindung. Auf Konsole kommt meist ein Plattform-Abo dazu (z. B. PlayStation Plus). Das ist der offizielle Multiplayer — nicht dasselbe wie Salerno Roleplay auf dem PC.',
    ],
    sections: [
      {
        title: 'Grundvoraussetzungen',
        items: [
          { type: 'list', value: ['GTA V (PC, PS4/PS5 oder Xbox) mit Online-Funktion', 'Rockstar Games Konto, verknüpft mit der Plattform', 'Stabile Internetleitung und freie Bandbreite für Patches', 'Auf Konsole: aktuelles Online-Abo der Plattform', 'Auf PC: aktuelle Treiber und ausreichend Speicherplatz'] },
          { type: 'text', value: 'Vor dem ersten Start Updates durchlaufen lassen und Speicher freiräumen — große Patches brechen sonst oft mitten im Download ab.' },
        ],
      },
      {
        title: 'Unterschied zu Salerno Roleplay',
        items: [
          { type: 'text', value: 'GTA Online ist Rockstars offizieller Mehrspieler-Modus mit eigenen Missionen und Economy. Salerno Roleplay läuft am PC über FiveM mit eigenen Serverregeln, Whitelist und Community — dafür reichen Konsolen-Versionen nicht aus.' },
        ],
      },
      {
        title: 'PC vs. Konsole kurz',
        items: [
          { type: 'text', value: 'Beide Plattformen können GTA Online. Nur der PC öffnet den Weg zu FiveM und Salerno Roleplay. Wenn dein Ziel RP bei uns ist, plane Hardware und Client entsprechend — Details unter ausführliche RP-Voraussetzungen.' },
        ],
      },
    ],
  },
  'schritt-fuer-schritt': {
    title: 'Schritt für Schritt GTA RP online spielen',
    intro: [
      'Der schnelle Ablauf für Installation, Serverwahl und ersten RP-Start — speziell für Salerno Roleplay. Folge diesen Schritten, um sauber auf unseren Server zu kommen.',
    ],
    sections: [
      {
        title: 'Der Ablauf',
        items: [
          { type: 'list', value: ['1) GTA V auf dem PC installieren und einmal starten.', '2) FiveM herunterladen und mit dem Rockstar-Konto verknüpfen.', '3) Tritt unserem Discord bei und lies das Regelwerk.', '4) Bewirb dich um die Whitelist für Salerno Roleplay.', '5) Charakter anlegen und die ersten Stunden beobachten statt eskalieren.'] },
        ],
      },
      {
        title: 'Tipps für den Einstieg',
        items: [
          { type: 'text', value: 'Nutze die Zeit vor der Whitelist, um unser Regelwerk und die FAQ durchzulesen. Ein gut vorbereiteter Charakter kommt bei Salerno weiter als einer, der nur auf Action aus ist.' },
        ],
      },
    ],
  },
};

export default function FAQDetail() {
  const { slug } = useParams();
  const entry = faqData[slug];

  if (!entry) {
    return (
      <div className="page faq-page">
        <h1>FAQ</h1>
        <p className="muted">Kein Eintrag gefunden.</p>
        <NavLink to="/faq" className="btn btn-outline" style={{ marginTop: 16 }}>
          Zurück zur FAQ-Übersicht
        </NavLink>
      </div>
    );
  }

  return (
    <div className="page faq-page">
      <NavLink to="/faq" className="faq-back">
        ← Zurück
      </NavLink>
      <h1>{entry.title}</h1>

      <div className="faq-intro">
        {entry.intro.map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </div>

      <div className="faq-sections">
        {entry.sections.map((section, index) => (
          <div key={index} className="faq-section-card">
            <h2>{section.title}</h2>
            <div className="faq-section-body">
              {section.items.map((item, itemIndex) => {
                if (item.type === 'text') {
                  return <p key={itemIndex}>{item.value}</p>;
                }
                if (item.type === 'list') {
                  return (
                    <ul key={itemIndex} className="faq-list-bullet">
                      {item.value.map((text, i) => (
                        <li key={i}>{text}</li>
                      ))}
                    </ul>
                  );
                }
                return null;
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
